const CivData = {
  civilizations: [
    {
      id: 15,
      name: "Aztecs",
      uniqueUnits: ["JaguarWarrior"],
      uniqueTechs: ["Atlatl", "GarlandWars"],
    },
    {
      id: 27,
      name: "Berbers",
      uniqueUnits: ["CamelArcher", "Genitour"],
      uniqueTechs: ["Kasbah", "MaghrebiCamels"],
    },
    {
      id: 1,
      name: "Britons",
      uniqueUnits: ["Longbowman"],
      uniqueTechs: ["Yeomen", "Warwolf"],
    },
    {
      id: 32,
      name: "Bulgarians",
      uniqueUnits: ["Konnik"],
      uniqueTechs: ["Stirrups", "Bagains"],
    },
    {
      id: 36,
      name: "Burgundians",
      uniqueUnits: ["Coustillier", "FlemishMilitia"],
      uniqueTechs: ["BurgundianVineyards", "FlemishRevolution"],
    },
    {
      id: 30,
      name: "Burmese",
      uniqueUnits: ["Arambai"],
      uniqueTechs: ["Howdah", "ManipurCavalry"],
    },
    {
      id: 7,
      name: "Byzantines",
      uniqueUnits: ["Cataphract"],
      uniqueTechs: ["GreekFire", "Logistica"],
    },
    {
      id: 13,
      name: "Celts",
      uniqueUnits: ["WoadRaider"],
      uniqueTechs: ["Stronghold", "FurorCeltica"],
    },
    {
      id: 6,
      name: "Chinese",
      uniqueUnits: ["ChuKoNu"],
      uniqueTechs: ["GreatWall", "Rocketry"],
    },
    {
      id: 34,
      name: "Cumans",
      uniqueUnits: ["Kipchak"],
      uniqueTechs: ["SteppeHusbandry", "CumanMercenaries"],
    },
    {
      id: 25,
      name: "Ethiopians",
      uniqueUnits: ["ShotelWarrior"],
      uniqueTechs: ["RoyalHeirs", "TorsionEngines"],
    },
    {
      id: 2,
      name: "Franks",
      uniqueUnits: ["ThrowingAxeman"],
      uniqueTechs: ["Chivalry", "BeardedAxe"],
    },
    {
      id: 3,
      name: "Goths",
      uniqueUnits: ["Huskarl"],
      uniqueTechs: ["Anarchy", "Perfusion"],
    },
    {
      id: 17,
      name: "Huns",
      uniqueUnits: ["Tarkan"],
      uniqueTechs: ["Marauders", "Atheism"],
    },
    {
      id: 21,
      name: "Incas",
      uniqueUnits: ["Kamayuk", "Slinger"],
      uniqueTechs: ["AndeanSling", "FabricShields"],
    },
    {
      id: 20,
      name: "Indians",
      uniqueUnits: ["ElephantArcher", "ImperialCamelRider"],
      uniqueTechs: ["Sultans", "Shatagni"],
    },
    {
      id: 99,
      name: "Indians",
      uniqueUnits: ["ElephantArcher", "ImperialCamelRider"],
      uniqueTechs: ["Sultans", "Shatagni"],
    },
    {
      id: 19,
      name: "Italians",
      uniqueUnits: ["GenoeseCrossbowman", "Condottiero"],
      uniqueTechs: ["Pavise", "SilkRoad"],
    },
    {
      id: 5,
      name: "Japanese",
      uniqueUnits: ["Samurai"],
      uniqueTechs: ["Yasama", "Kataparuto"],
    },
    {
      id: 28,
      name: "Khmer",
      uniqueUnits: ["BallistaElephant"],
      uniqueTechs: ["TuskSwords", "DoubleCrossbow"],
    },
    {
      id: 18,
      name: "Koreans",
      uniqueUnits: ["WarWagon", "TurtleShip"],
      uniqueTechs: ["Panokseon", "Shinkichon"],
    },
    {
      id: 35,
      name: "Lithuanians",
      uniqueUnits: ["Leitis"],
      uniqueTechs: ["HillForts", "TowerShields"],
    },
    {
      id: 22,
      name: "Magyars",
      uniqueUnits: ["MagyarHuszar"],
      uniqueTechs: ["CorvinianArmy", "RecurveBow"],
    },
    {
      id: 29,
      name: "Malay",
      uniqueUnits: ["KarambitWarrior"],
      uniqueTechs: ["Thalassocracy", "ForcedLevy"],
    },
    {
      id: 26,
      name: "Malians",
      uniqueUnits: ["Gbeto"],
      uniqueTechs: ["Tigui", "Farimba"],
    },
    {
      id: 16,
      name: "Mayans",
      uniqueUnits: ["PlumedArcher"],
      uniqueTechs: ["ObsidianArrows", "ElDorado"],
    },
    {
      id: 12,
      name: "Mongols",
      uniqueUnits: ["Mangudai"],
      uniqueTechs: ["Nomads", "Drill"],
    },
    {
      id: 8,
      name: "Persians",
      uniqueUnits: ["WarElephant"],
      uniqueTechs: ["Kamandaran", "Mahouts"],
    },
    {
      id: 24,
      name: "Portuguese",
      uniqueUnits: ["OrganGun", "Caravel"],
      uniqueTechs: ["Carrack", "Arquebus"],
    },
    {
      id: 9,
      name: "Saracens",
      uniqueUnits: ["Mameluke"],
      uniqueTechs: ["Madrasah", "Zealotry"],
    },
    {
      id: 37,
      name: "Sicilians",
      uniqueUnits: ["Serjeant"],
      uniqueTechs: ["FirstCrusade", "Scutage"],
    },
    {
      id: 23,
      name: "Slavs",
      uniqueUnits: ["Boyar"],
      uniqueTechs: ["Orthodoxy", "Druzhina"],
    },
    {
      id: 14,
      name: "Spanish",
      uniqueUnits: ["Conquistador", "Missionary"],
      uniqueTechs: ["Inquisition", "Supremacy"],
    },
    {
      id: 33,
      name: "Tatars",
      uniqueUnits: ["Keshik", "FlamingCamel"],
      uniqueTechs: ["SilkArmor", "TimuridSiegecraft"],
    },
    {
      id: 4,
      name: "Teutons",
      uniqueUnits: ["TeutonicKnight"],
      uniqueTechs: ["Ironclad", "Crenellations"],
    },
    {
      id: 10,
      name: "Turks",
      uniqueUnits: ["Janissary"],
      uniqueTechs: ["Sipahi", "Artillery"],
    },
    {
      id: 31,
      name: "Vietnamese",
      uniqueUnits: ["RattanArcher"],
      uniqueTechs: ["Chatras", "PaperMoney"],
    },
    {
      id: 11,
      name: "Vikings",
      uniqueUnits: ["Berserk", "Longboat"],
      uniqueTechs: ["Chieftains", "Berserkergang"],
    },
    {
      id: 38,
      name: "Poles",
      uniqueUnits: ["Obuch", "Winged Hussar"],
      uniqueTechs: ["Szlachta Privileges", "Lechitic Legacy"],
    },
    {
      id: 39,
      name: "Bohemians",
      uniqueUnits: ["Hussite Wagon", "Houfnice"],
      uniqueTechs: ["Wagenburg Tactics", "Hussite Reforms"],
    },
    {
      id: 40,
      name: "Dravidians",
      uniqueUnits: ["Urumi Swordsman", "Thirisadai"],
      uniqueTechs: ["Medical Corps", "Wootz Steel"],
    },
    {
      id: 41,
      name: "Bengalis",
      uniqueUnits: ["Ratha"],
      uniqueTechs: ["Paiks", "Mahayana"],
    },
    {
      id: 42,
      name: "Gurjaras",
      uniqueUnits: ["Chakram Thrower", "Shrivamsha Rider"],
      uniqueTechs: ["Kshatriyas", "Frontier Guards"],
    },
    {
      id: 43,
      name: "Hindustanis",
      uniqueUnits: ["Grand Trunk Road", "Shatagni"],
      uniqueTechs: ["Ghulam", "Imperial Camel Rider"],
    },
  ],
};

export default CivData;
